import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

// Keep existing bookmarks and notification/email links working after the rename.
const LegacyAuctionRedirect: React.FC = () => {
  const location = useLocation();
  const pathname = location.pathname === '/my-wins'
    ? '/game-a-rama/my-wins'
    : location.pathname.replace(/^\/auctions(?=\/|$)/, '/game-a-rama');

  return <Navigate to={{ pathname, search: location.search, hash: location.hash }} state={location.state} replace />;
};

export default LegacyAuctionRedirect;
